module.exports = __webpack_public_path__ + "img/limb_types_labelled.5ed25016.jpg";